module.exports = __webpack_public_path__ + "img/19.1d23206c.jpg";